import React, { useCallback, useEffect, useState } from "react";

// Material UI
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

// Components
import Input from "../../inputs/input";
import Modal from "../../modal";
import Dropdown from "../../inputs/dropdown";
import CardCouponSelector from "./CardCouponSelector";
import { subChannels } from "../../../models/Channels";
import useUser from "../../../hooks/user/useUser";
import { Typography } from "@mui/material";
// Others

const ExtraDataModal = ({ open, onSave, onClose, showManual, showRefundCupon, showPv, order, showCreditNote, refundAmount = 0 }) => {
  const { branch, pv } = useUser();
  const [isCuponValid, setIsCuponValid] = useState(false);
  const [form, setForm] = useState({
    manualInvoiceNumber: "",
    billingCode: "",
    manualCreditNoteNumber: ""
  });


  const getPvs = useCallback(() => 
    branch?.pvs.filter(pv => pv.subChannel === subChannels.values.FacturaManual ) || []
  , [branch.pvs])
  
  const handleInputChange = (event) => {
    if (event.target.name === 'multipleFields') {
      setForm(event.target.value);
    } else {
      setForm({ ...form, [event.target.name]: event.target.value });
    }
  };

  const handleSave = () => {
    let data = [];

    if(showRefundCupon) {
      const firstPayment = { paymentId: form.payment1, amount: Number(form.amount1), number: Number(form.cuponNumber1)}
      const secondPayment = { paymentId: form.payment2, amount: Number(form.amount2), number: Number(form.cuponNumber2)}
    
      data = [firstPayment];

      if(form.payment2)
        data.push(secondPayment);  
    }
    
    const manualInvoiceNumber = Number(form.manualInvoiceNumber);
    const manualCreditNoteNumber = Number(form.manualCreditNoteNumber);
    onSave({
        manualInvoiceData: {  
            manualInvoiceNumber,
            billingCode: Number(form.billingCode), 
            manualCreditNoteNumber: manualCreditNoteNumber > 0 ? manualCreditNoteNumber : manualInvoiceNumber 
        },
        refundCupons: data
    })
  };
  
  const isValid = () => {
      let valid = true;
      if(showManual) {
        valid = valid && isValidManual();
        if(showCreditNote)
          valid = valid && isValidManualCreditNote();
      }

     if(showRefundCupon)
          valid = valid && isCuponValid;

      return valid;
  }

  const isValidManual = () => 
    (form.manualInvoiceNumber && showPv && form.billingCode) || 
    (form.manualInvoiceNumber && !showPv)
  
  const isValidManualCreditNote = () => 
    (form.manualCreditNoteNumber && showCreditNote && form.manualInvoiceNumber) || 
    (form.manualCreditNoteNumber && !showCreditNote)

  const handleCuponValidationChange = (isValid) => {
    setIsCuponValid(isValid);
  };

  return (
    <Modal
      maxWidth="xs"
      open={open}
      onClose={onClose}
      title="Extra Data"
      contentProps={{ dividers: true }}
      customButtons={() => (
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSave}
            disabled={!isValid()}
          >
            Guardar
          </Button>
        </DialogActions>
      )}
    >
      { showManual &&
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant='inherit' color='primary'> Factura Manual: </Typography>
          </Grid>
          <Grid size={12}>
            <Input
                required
                fullWidth
                label="Numero de Comprobante"
                name="manualInvoiceNumber"
                type="number"
                onChange={handleInputChange}
                value={form.manualInvoiceNumber}
            />
          </Grid>
          { showPv === true &&
            <Grid size={12}>
                <Dropdown 
                    fullWidth
                    required
                    name='billingCode'
                    label='Punto de Venta'
                    getOptionLabel={(option) => option?.name || ''}
                    getOptionValue={(option) => option?.billingCode || ''} 
                    onChange={handleInputChange}
                    value={form.billingCode || ''}
                    values={getPvs()} 
                />
            </Grid>}
          { showCreditNote === true &&
             <Grid size={12}>
              <Input
                  required
                  fullWidth
                  label="Numero de Nota de Credito"
                  name="manualCreditNoteNumber"
                  type="number"
                  onChange={handleInputChange}
                  value={form.manualCreditNoteNumber}
              />
            </Grid>}
        </Grid>}
      { showRefundCupon &&
        <CardCouponSelector
          order={order}
          form={form}
          handleInputChange={handleInputChange}
          hasTerminal={pv?.hasTerminal}
          refundAmount={refundAmount}
          onValidationChange={handleCuponValidationChange}
        />
      }
    </Modal>
  );
};


export default ExtraDataModal;
